import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import Loading from '../../components/layouts/Loading'
import { bucket_url } from '../../constants/const'
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { BiChevronRight } from "react-icons/bi";
import Marquee from 'react-fast-marquee';
import Logo from '../../assets/images/RetinaLogo.png'

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core';

import HeroSlider from '../../components/heroSlider/heroSlider.component';
import PageTitle from '../../components/pageTitle/pageTitle.component';
import PhotoGallery from '../../components/photoGallery/photoGallery.component';
import VideoGallery from '../../components/videoGallery/videoGallery.component';
import BlogCard from '../../components/blogCard/blogCard.component';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import DummyRightBg from '../../assets/images/dummy/dummyRightBg.png';
import DummyCourseBanner from '../../assets/images/dummy/DummyCourseBanner.png';

import './home.module.css';
import CourseCard from '../../components/courseCard/courseCard.component';
import PublicationCarousel from '../../components/publicationCarousel/publicationCarousel';
import TestimonialGallery from '../../components/testimonialGallery/testimonialGallery.component';
import { Link } from 'react-router-dom';


const HomePage = props => {

    const [featuredPublicaiton, setFeaturedPublication] = useState([])
    const [featuredCourses, setFeaturedCourses] = useState(null)
    const [allHighlighters, setAllHighlighters] = useState(null)
    const [allExclusives, setAllExclusives] = useState(null)
    const [highlightSectionInfo, setHighlightSectionInfo] = useState(null)
    const [exclusivesSectionInfo, setExclusivesSectionInfo] = useState(null)

    const {
        loading,
        // homeStatistics,
        publications,
        // originality,
        highlighter,
        // notices,
        // photos,
        // blog,
        highlightInfo,
        exclusiveInfo,
        courseModule,
        exclusives
    } = useSelector(state => state.all)

    useEffect(() => {
        if (highlightInfo) {
            setHighlightSectionInfo(highlightInfo)
        }
    }, [highlightInfo])

    useEffect(() => {
        if (exclusiveInfo) {
            setExclusivesSectionInfo(exclusiveInfo)
        }
    }, [exclusiveInfo])

    useEffect(() => {
        if (courseModule && courseModule.length > 0) {
            setFeaturedCourses(courseModule.filter(item => (item.featuredAt && item.status === 'show')))
        }
    }, [courseModule])

    useEffect(() => {
        console.log('highlighter.length', highlighter.length)

        if (!!highlighter && highlighter.length > 0) {
            setAllHighlighters(highlighter)
        }
    }, [highlighter])

    useEffect(() => {
        if (!!exclusives && exclusives.length > 0) {
            setAllExclusives(exclusives)
        }
    }, [exclusives])

    useEffect(() => {
        if (publications && publications.length > 0) {
            setFeaturedPublication(publications.filter(item => item.featuredAt))
        }
    }, [publications])

    useEffect(() => {
        if (featuredPublicaiton.length < 4) {
            setFeaturedPublication(prev => ([...prev, ...publications]))
        }
    }, [featuredPublicaiton])

    // useEffect(() => {

    //     // if (originality) {
    //     //     if (originality.description) {
    //     //         document.getElementById('originaliy-description').innerHTML = originality.description
    //     //     }
    //     // }


    //     if (homeStatistics) {
    //         if (homeStatistics.qoute) {
    //             document.getElementById('home-statistics').innerHTML = homeStatistics.qoute
    //         }
    //     }
    // }, [originality, originality.description])

    return (
        <div>
            {/* Hero Slider Start */}
            <Container>
                <Row>
                    <Col xs={12}>
                        <HeroSlider />
                    </Col>
                </Row>
            </Container>
            {/* Hero Slider End */}
            {/* Notices Start */}
            {/* <section styleName="notices-section">
                <Container>
                    {loading ? <Loading /> : (
                        <Row>
                            <Col xs={12}>
                                <Marquee
                                    styleName="notice-container"
                                    direction="left"
                                    delay={0}
                                    gradient={true}
                                    gradientColor={[248, 251, 253]}
                                    pauseOnClick={false}
                                    pauseOnHover={true}
                                    speed={100}
                                >
                                    {notices && notices.map(item => <h5 styleName="notice-item"><a href={item.url} target="_blank" rel="noreferrer" >{item.text}</a></h5>)}
                                </Marquee>
                            </Col>
                        </Row>
                    )}
                </Container>
            </section> */}
            {/* Notices End */}

            {/* Info Highlight Start */}
            {
                !!allHighlighters &&
                <section className='info-highlight-section' styleName="info-highlight-section">
                    <PageTitle
                        title={highlightInfo?.highlightTitle}
                    />
                    <Container>
                        {loading ? <Loading /> :
                            <div className="info-highlight-card-wrap box-shadow-danger p-4">
                                <Row className="align-items-center">
                                    <Col xs={12} lg={7} className="mb-4 mb-lg-0">
                                        <Row className="align-items-center">
                                            {allHighlighters.map(item => (
                                                <Col xs={12} lg={6} className="flex-grow-1 mb-0 mb-lg-3" key={`key_${item._id}`}>
                                                    <Card className="info-highlight-card text-center border-0">
                                                        <Card.Body className='d-flex align-items-center'>
                                                                <Image styleName="info-highlight-img" className="flex-shrink-0 d-block mx-auto" src={`${bucket_url}${item.image}`} alt="icon" />
                                                                <Card.Title className='flex-1 mb-0'>{item.title}</Card.Title>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Col>
                                    <Col xs={12} lg={5} className="align-self-center">
                                        <img className='banner-img img-fluid' src={`${bucket_url}${highlightSectionInfo?.highlightImage}`} alt="bg" />
                                    </Col>
                                </Row>
                            </div>
                        }

                    </Container>
                </section>
            }
            {/* Info Highlight End */}

            {/* Featured Course Start */}
            {
                !!featuredCourses &&
                <section className='featured-course-section'>
                    <PageTitle
                        title="মেডিকেল ও ভার্সিটির সম্পূর্ণ প্রস্তুতি"
                    />
                    <Container>
                        <Row className='justify-content-center'>
                            {
                                featuredCourses.map((item, index) => {
                                    if(index < 3) {
                                        return (
                                            <Col className="mb-4" xs={12} md={6} lg={4}>
                                                <CourseCard
                                                    link={`/courses/${item.title.replace(/ /g, "-")}/${item._id}`}
                                                    price={'item.price'}
                                                    discount={'item.discount'}
                                                    banner={`${bucket_url}${item.coverPhoto}`}
                                                    title={item.title}
                                                    subTitle={item.description}
                                                    id={item._id}
                                                    description={item.description}
                                                    session={item.session}
                                                />
                                            </Col>
                                        )
                                    }
                                })
                            }
                        </Row>
                        <Row className='justify-content-center mt-4'>
                            <Col xs={24}>
                                <LinkContainer to={'/courses'}>
                                    <Button className='default-theme-btn section-more'>সকল কোর্স <BiChevronRight /></Button>
                                </LinkContainer>
                            </Col>
                        </Row>
                    </Container>
                </section>
            }
            {/* Featured Course End */}

            {/* Publication Start */}
            <section styleName="publication-section">
                <PageTitle
                    title="আমাদের প্রকাশনাসমূহ"
                />
                <Container>
                    <Row>
                        <Col xs={12}>
                            {
                                featuredPublicaiton && featuredPublicaiton.length > 0
                                ? <PublicationCarousel featuredPublicaiton={featuredPublicaiton} />
                                : <PublicationCarousel publications = {publications}/>
                            }
                        </Col>
                    </Row>
                    <Row className='justify-content-center mt-5'>
                        <Col xs={24}>
                            <LinkContainer to="/publications">
                                <Button className='default-theme-btn section-more'>সকল  প্রকাশনা <BiChevronRight /></Button>
                            </LinkContainer>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* Publication End */}

            {
                // console.log('highlightInfo', highlightInfo)
                // && console.log('highlightSectionInfo', highlightSectionInfo)
                // && console.log('exclusivesSectionInfo', exclusivesSectionInfo)
            }

            {/* Retina Exclusive Start */}
            {loading ? <Loading /> :
                (!!allExclusives ?
                    <section className='retina-exclusive-section' styleName="info-highlight-section">
                        <PageTitle
                            title={
                                // <div className='d-flex align-items-center justify-content-center'>
                                //     <img className='mr-3' src={Logo} alt="retina logo" style={{ height: 45 }} />
                                //     <span>এক্সক্লুসিভ</span>
                                // </div>
                                exclusivesSectionInfo?.exclusiveTitle
                            }
                            subTitle={exclusivesSectionInfo?.exclusiveSubtitle}
                        />
                        <Container>
                            <div className="info-highlight-card-wrap box-shadow-danger p-4">
                                <Row className="align-items-center">
                                    <Col xs={12} lg={7} className="mb-4 mb-lg-0">
                                        <Row className="align-items-center">
                                            {allExclusives.map(item => (
                                                <Col xs={12} lg={6} className="flex-grow-1 mb-0 mb-lg-3" key={`key_${item._id}`}>
                                                    <Card className="info-highlight-card text-center border-0">
                                                        <Card.Body className='d-flex align-items-center'>
                                                                <Image styleName="info-highlight-img" className="flex-shrink-0 d-block mx-auto" src={`${bucket_url}${item.image}`} alt="icon" />
                                                                <Card.Title className='flex-1 mb-0'>{item.title}</Card.Title>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Col>
                                    <Col xs={12} lg={5} className="align-self-center">
                                        <img className='banner-img img-fluid' src={`${bucket_url}${exclusivesSectionInfo?.exclusiveImage}`} alt="bg" />
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section>
                : null)
            }
            {/* Retina Exclusive End */}


            {/* Success Section Start */}
            <div className="success-section">
                {/* Video Gallery Start */}
                <section styleName="video-gallery-section">
                    <PageTitle
                        title="সাফল্য কথা"
                    />
                    <Container>
                        {loading ? <Loading /> : (
                            <>
                                <Row>
                                    <Col xs={12}>
                                        <VideoGallery />
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Container>
                </section>
                {/* Video Gallery end */}
                {/* testimonial start */}
                <section>
                    <Container>
                    {loading ? <Loading /> : (
                        <>
                            <Row>
                                <Col xs={12}>
                                    <TestimonialGallery />
                                </Col>
                            </Row>
                        </>
                    )}
                    </Container>
                </section>
                {/* testimonial end */}
            </div>
            {/* Success Section end */}

        </div>
    )
};

export default HomePage;